/**
 * Recommendation Display Component
 * Shows irrigation recommendations in formatted text
 */

const React = require('react');
const PropTypes = require('prop-types');
require('./RecommendationDisplay.css');

/**
 * Formats recommendation text based on frequency
 * @param {number} amount - Irrigation amount
 * @param {string} unit - Unit of measurement
 * @param {number} frequencyDays - Days between irrigations
 * @param {number} timesPerWeek - Times per week
 * @returns {string}
 */
const formatRecommendation = (amount, unit, frequencyDays, timesPerWeek) => {
  const formattedAmount = `${amount.toFixed(1)}${unit}`;

  if (timesPerWeek && timesPerWeek > 0) {
    return `${formattedAmount} ${timesPerWeek} times a week`;
  }

  if (frequencyDays && frequencyDays > 0) {
    return `${formattedAmount} every ${frequencyDays} ${frequencyDays === 1 ? 'day' : 'days'}`;
  }

  return formattedAmount;
};

/**
 * RecommendationDisplay component
 * @param {Object} props
 * @param {number} props.amount - Irrigation amount
 * @param {string} props.unit - Unit of measurement
 * @param {number} props.frequencyDays - Days between irrigations
 * @param {number} props.timesPerWeek - Times per week
 * @param {string} props.displayText - Pre-formatted display text (optional)
 */
const RecommendationDisplay = ({
  amount,
  unit,
  frequencyDays,
  timesPerWeek,
  displayText,
}) => {
  // Hide component if no data
  if (!amount && !displayText) {
    return null;
  }

  const text =
    displayText ||
    formatRecommendation(amount, unit, frequencyDays, timesPerWeek);

  return (
    <div className='recommendation-display'>
      <div className='recommendation-display__header'>
        <span
          className='text-style-short-lables-12-semi-bold'
          style={{ color: 'var(--color-grey-45)' }}
        >
          Recommendation
        </span>
      </div>
      <div className='recommendation-display__content'>
        <span
          className='text-style-short-lables-14-regular'
          style={{ color: 'var(--color-grey-34)' }}
        >
          {text}
        </span>
      </div>
    </div>
  );
};

RecommendationDisplay.propTypes = {
  amount: PropTypes.number,
  unit: PropTypes.string,
  frequencyDays: PropTypes.number,
  timesPerWeek: PropTypes.number,
  displayText: PropTypes.string,
};

RecommendationDisplay.defaultProps = {
  amount: 0,
  unit: 'mm',
  frequencyDays: 0,
  timesPerWeek: 0,
  displayText: '',
};

module.exports = RecommendationDisplay;
